<template>
  <component
    class="layout"
    :class="layout"
    :is="layout"
    v-if="innerWidth >= 980"
  />
  <div
    class="splash flex flex-col items-center pt-56"
    v-else
  >
    <a href="https://apps.apple.com/app/good-cop-bad-cop/id1469493989">
      <img src="/images/stores/appstore.png" alt="App Store" class="sm:mt-12 md:mt-24 w-48">
    </a>
    <a href="https://play.google.com/store/apps/details?id=com.divinedigitalagency.app.android">
      <img src="/images/stores/googleplay.png" alt="Google Play" class="mt-4 w-48">
    </a>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      innerWidth: window.innerWidth,
    };
  },
  computed: {
    ...mapGetters('auth', ['isAuthenticated']),

    defaultLayout() {
      return 'landing';
    },

    layout() {
      return `${this.$route.meta.layout || this.defaultLayout}-layout`;
    },
  },
  watch: {
    isAuthenticated: {
      immediate: true,
      handler(value) {
        if (value) {
          this.fetch();
        }
      }
    },
  },
  created() {
    window.addEventListener('resize', this.onResize);
  },
  methods: {
    ...mapActions('profile', ['fetch']),

    onResize() {
      this.innerWidth = window.innerWidth;
    },
  },
};
</script>

<style>
@tailwind base;
@tailwind components;
@tailwind utilities;

html, body, .landing-layout {
  height: 100%;
  color: #282F41;
}

html {
  overflow-x: hidden;
}
</style>

<style lang="scss">
.legacy-html {
    h1 {
      font-size: 2em;
      font-weight: bold;
    }

    h2 {
      font-size: 1.5em;
      font-weight: bold;
    }

    blockquote,
    dl,
    dd,
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    figure,
    p,
    pre {
      margin-block-start: 1em;
      margin-block-end: 1em;
      margin-inline-start: 0px;
      margin-inline-end: 0px;
    }

    ol,
    ul {
      list-style-type: disc;
      margin-block-start: 1em;
      margin-block-end: 1em;
      margin-inline-start: 0px;
      margin-inline-end: 0px;
      padding-inline-start: 40px;
    }
  }
</style>

<style scoped>
.splash {
  background-image: url("/images/splash.png");
  height: 100vh;
  width: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  background-position-x: center;
}
</style>
